import React, { useState } from 'react';
import moment from 'moment';
import Colors from '../../../constants/Colorsv2';

//Import redux actions

import { Icon } from 'react-native-elements';
import { View, TouchableOpacity, Image } from 'react-native';
import { Text } from '../../../globalComponents/NativeOverrides';
import { PlayerNotificationProps } from '../../../store/types/auth_svc';

type NotificationCardProps = {
    navigation:any,
    notification:PlayerNotificationProps,
    onRemove:(pn:PlayerNotificationProps) => void
}
const BENotification = ({ navigation, notification, onRemove }:NotificationCardProps) => {
    const [ notificationSize, setNotificationSize ] = useState({ x:0, y:0, height:0, width:0 })

    const handleRemoveNotification = () => {
        if(!onRemove){ return }
        onRemove(notification)
    }

    const handleSelect = (notification:any) => {
        navigation.navigate(notification.options.data.pageStack, { screen: notification.options.data.page, initial: false, params: notification.options.data.pageParams })
    } 


    const assignNotificationIcon = (notification:any) => {
        if(!notification.type){ return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1644418373/notify_icon_markets_fdr2fo.webp' }
        switch(notification.type){
            case 'COMPETITION':
                return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1644418373/notify_icon_comps_xroh2j.webp'
            case 'MARKET':
                return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1644418373/notify_icon_markets_fdr2fo.webp'
            case 'SOCIAL':
                return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1644418373/notify_icon_message_yaynnk.webp'
            case 'MARKETING':
                return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1644418378/notify_icon_be_mclddf.webp'
            default:
                return 'https://res.cloudinary.com/hoabts6mc/image/upload/v1644418373/notify_icon_markets_fdr2fo.webp'
        }
    }

    const image_size = notificationSize.width / 8
    return (
        <View style={{ flex:1, flexDirection:'row', borderBottomWidth:1, borderColor:Colors.shades.shade100 }} onLayout={(ev) => {
            const { x, y, width, height } = ev.nativeEvent.layout;
            setNotificationSize({x, y, width, height})
        }}>
            {notificationSize.width !== 0 ?
            <>
            <TouchableOpacity style={{ flex:9/10, flexDirection:'row' }} onPress={() => handleSelect(notification)}>
                <View style={{ backgroundColor:notification.type==='MARKETING'?Colors.brand.electric:Colors.shades.white, padding:5, paddingTop:15 }}>
                    <Image style={{ width:image_size, height:image_size }} source={assignNotificationIcon(notification)} />
                </View>
                <View style={{ flex:1, padding:10 }}>
                    <Text size={14} weight='semibold' color={Colors.brand.midnight}>{notification.title}</Text>
                    <Text size={14} weight='regular' color={Colors.brand.midnight}>{notification.body}</Text>
                    <Text size={12} weight='light' color={Colors.brand.slate}>{moment(notification.create_datetime).fromNow()}</Text>
                </View>
            </TouchableOpacity>
            <TouchableOpacity style={{ flex:1/10, alignItems:'center', paddingTop:10 }} onPress={() => handleRemoveNotification()}>
                <Icon name='x' type='feather' color={Colors.brand.slate} size={16} />
            </TouchableOpacity>
            </>
            :<></>}
        </View>
    )
}



export default BENotification;
